















































































import button from '../../../shared/directives/button.js';
import CalendarEventSendReminder from '../../../shared/PageFragments/CalendarEvent/CalendarEventSendReminder.vue';
import { PropType } from 'vue';
import { EventData } from '../../business/calendar/eventData';
export default {
  name: 'CalendarEventResponseTypeInvitee',
  components: { CalendarEventSendReminder },
  directives: {
    button,
  },
  props: {
    invitees: {
      type: Array,
      required: true,
    },
    groupHomeInvitees: { type: Array, default: () => [] },
    showParticipantInformation: { type: Boolean, default: false },
    showReminder: { type: Boolean, default: false },
    eventData: { type: Object as PropType<EventData>, default: null },
  },
  emits: ['reminderSent'],
  data: function () {
    return {
      isSubGroupOpen: false,
    };
  },
  computed: {
    inviteeCount() {
      return this.invitees.length + this.groupHomeInvitees.length;
    },
    totalAdults() {
      return (
        this.invitees.reduce((sum, invitee) => sum + invitee.numberOfAdultParticipants || 0, 0) +
        this.groupHomeInvitees.reduce((sum, invitee) => sum + invitee.numberOfAdultParticipants || 0, 0)
      );
    },
    totalChildren() {
      return (
        this.invitees.reduce((sum, invitee) => sum + invitee.numberOfChildParticipants || 0, 0) +
        this.groupHomeInvitees.reduce((sum, invitee) => sum + invitee.numberOfChildParticipants || 0, 0)
      );
    },
  },
  methods: {
    onSubGroupClicked() {
      this.isSubGroupOpen = !this.isSubGroupOpen;
    },
    emitReminderSent() {
      this.$emit('reminderSent');
    },
  },
};
